module.exports = __webpack_public_path__ + "img/PT5020.a7fceb78.png";